/**
 * Calculates percentage, ensuring result is a number and handling division by zero.
 * @param {number} value - The numerator.
 * @param {number} divisor - The denominator.
 * @returns {number} The calculated percentage, or 0 if divisor is falsy.
 */
export const calculatePercentage = (value, divisor) => {
    if (!divisor) return 0;
    return Math.round((Number(value) / Number(divisor)) * 100) || 0;
  };
  
  /**
   * Formats the common base data for a recruit, including P and F column calculations.
   * @param {Object} recruit - The raw recruit object.
   * @param {Object} formulas - The formulas object for the recruit (e.g., formulasMapping[recruit.id]).
   * @returns {Object} The base formatted recruit data.
   */
  export const formatBaseRecruitData = (recruit, formulas = {}) => {
    return {
      rating: recruit.rating || 0,
      id: recruit.id,
      smgn: recruit.code,
      status: recruit.status,
      code: recruit.code,
      first_name: recruit.firstName,
      last_name: recruit.lastName,
      company: recruit.Company?.name || '',
      team: recruit.Team?.name || '',
      department: recruit.Department?.name || '',
      division: recruit.Division?.name || '',
      position: recruit.Position?.name || '',
      date_of_interview: recruit?.interviewAt || '',
      date_of_translate: recruit?.decryptionAt || '',
      commentary: recruit.comment,
      date_of_offer: recruit.employmentAt,
      date_of_fired: recruit.dismissalAt,
      working_phone: recruit.personalPhone,
      NDA_date: recruit.acceptNDA ? 'Yes' : 'No',
      FB_IG: recruit.fbMg,
      linkedin: recruit.linkedin,
      phone_number: recruit.personalPhone, // Common field
  
      // P Columns - Calculated Percentages
      P01_0: calculatePercentage(recruit.P01_0, recruit.P01divisor),
      P01_1: calculatePercentage(recruit.P01_1, recruit.P01divisor),
      P01_2: calculatePercentage(recruit.P01_2, recruit.P01divisor),
      P01_3: calculatePercentage(recruit.P01_3, recruit.P01divisor),
      P01_4: calculatePercentage(recruit.P01_4, recruit.P01divisor),
      P02_0: calculatePercentage(recruit.P02_0, recruit.P02divisor),
      P02_1: calculatePercentage(recruit.P02_1, recruit.P02divisor),
      P03_0: calculatePercentage(recruit.P03_0, recruit.P03divisor),
      P03_1: calculatePercentage(recruit.P03_1, recruit.P03divisor),
      P04_0: calculatePercentage(recruit.P04_0, recruit.P04divisor),
      P04_1: calculatePercentage(recruit.P04_1, recruit.P04divisor),
      P05_0: calculatePercentage(recruit.P05_0, recruit.P05divisor),
      P05_1: calculatePercentage(recruit.P05_1, recruit.P05divisor),
      P06_0: calculatePercentage(recruit.P06_0, recruit.P06divisor),
      P06_1: calculatePercentage(recruit.P06_1, recruit.P06divisor),
      P07_0: calculatePercentage(recruit.P07_0, recruit.P07divisor),
      P07_1: calculatePercentage(recruit.P07_1, recruit.P07divisor),
      P07_2: calculatePercentage(recruit.P07_2, recruit.P07divisor),
      P08_0: calculatePercentage(recruit.P08_0, recruit.P08divisor),
      P08_1: calculatePercentage(recruit.P08_1, recruit.P08divisor),
      P09_0: calculatePercentage(recruit.P09_0, recruit.P09divisor),
      P09_1: calculatePercentage(recruit.P09_1, recruit.P09divisor),
      P10_0: calculatePercentage(recruit.P10_0, recruit.P10divisor),
      P10_1: calculatePercentage(recruit.P10_1, recruit.P10divisor),
      P11_0: calculatePercentage(recruit.P11_0, recruit.P11divisor),
      P11_1: calculatePercentage(recruit.P11_1, recruit.P11divisor),
  
      // F Columns - Calculated from fetched formulas
      F1: formulas ? Math.round((formulas.F1 ?? 0) * 100) : 0,
      F2: formulas ? Math.round((formulas.F2 ?? 0) * 100) : 0,
      F3: formulas ? Math.round((formulas.F3 ?? 0) * 100) : 0,
      F4: formulas ? Math.round((formulas.F4 ?? 0) * 100) : 0,
      F5: formulas ? Math.round((formulas.F5 ?? 0) * 100) : 0,
      F6: formulas ? Math.round((formulas.F6 ?? 0) * 100) : 0,
      F7: formulas ? Math.round((formulas.F7 ?? 0) * 100) : 0,
      F8: formulas ? Math.round((formulas.F8 ?? 0) * 100) : 0,
      F9: formulas ? Math.round((formulas.F9 ?? 0) * 100) : 0,
      F10: formulas ? Math.round((formulas.F10 ?? 0) * 100) : 0,
      F11: formulas ? Math.round((formulas.F11 ?? 0) * 100) : 0,
      F12: formulas ? Math.round((formulas.F12 ?? 0) * 100) : 0,
    };
  };